module.exports = __webpack_public_path__ + "img/case_8.bdb3fbb7.png";